<template>
  <!-- why you do this ? ;(( -->
  <LayoutPopup id="them-thuoc-tinh">
    <template #title>Thuộc tính sản phẩm</template>

    <template #content>
      <validation-observer
        ref="observerPropertyItems"
        id="observerPropertyItems"
        v-slot="{ validate }"
      >
        <form ref="formPropertyItems" >
          <div class="__options">
            <div
              class="__option"
              v-for="(option, optionIndex) in list"
              :key="optionIndex"
            >
              <div class="__controls">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="cursor: pointer"
                  @click="deleteOption(optionIndex)"
                  v-if="type != 'detail-item'"
                >
                  <path
                    d="M10.0001 1.414L8.5861 0L5.0501 3.536L1.5141 0L0.100098 1.414L3.6361 4.95L0.100098 8.486L1.5141 9.9L5.0501 6.364L8.5861 9.9L10.0001 8.486L6.4641 4.95L10.0001 1.414Z"
                    fill="#74788D"
                  />
                </svg>
              </div>

              <div class="__field">
                <div class="__label">Thuộc tính</div>
                <BaseInput
                  placeholder="Nhập thuộc tính"
                  :name="'Thuộc tính'"
                  :rules="'lBetween:1,255|CHECK_HTML'"
                  :validate="option.error"
                  v-model="option.name"
                  @enter="$event.target.nextElementSibling.focus()"
                />
              </div>

              <div class="__field">
                <div class="__label">Giá trị</div>

                <div class="__inputs">
                  <draggable v-model="option.values">
                    <div
                      v-for="(value, index) in option.values"
                      :key="value.id"
                    >
                      <BaseInputIcon
                        placeholder="Nhập giá trị"
                        :value="value.text"
                        :name="'Giá trị'"
                        :rules="``"
                        :validate="value.error"
                        @value="getValue($event, optionIndex, index)"
                        @enter="$event.target.nextElementSibling.focus()"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style="cursor: pointer"
                        >
                          <path
                            d="M10.521 10.4056V7.38477H12.5002C12.7606 7.38477 12.9168 7.04622 12.7085 6.83789L10.2085 4.33789C10.0783 4.20768 9.896 4.20768 9.76579 4.33789L7.26579 6.83789C7.05745 7.04622 7.2137 7.38477 7.47412 7.38477H9.47933V10.4056H6.4585V8.40039C6.4585 8.13997 6.11995 7.98372 5.91162 8.19206L3.41162 10.6921C3.28141 10.8223 3.28141 11.0046 3.41162 11.1348L5.91162 13.6348C6.11995 13.8431 6.4585 13.6868 6.4585 13.4264V11.4473H9.47933V14.4421H7.47412C7.2137 14.4421 7.05745 14.7806 7.26579 14.9889L9.76579 17.4889C9.896 17.6191 10.0783 17.6191 10.2085 17.4889L12.7085 14.9889C12.9168 14.7806 12.7606 14.4421 12.5002 14.4421H10.495V11.4473H13.5158V13.4264C13.5158 13.6868 13.8543 13.8431 14.0627 13.6348L16.5627 11.1348C16.6929 11.0046 16.6929 10.8223 16.5627 10.6921L14.0627 8.19206C13.8543 7.98372 13.5158 8.13997 13.5158 8.40039V10.4056H10.521Z"
                            fill="#808890"
                          />
                        </svg>

                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style="cursor: pointer"
                          @click="deleteValue(optionIndex, index)"
                          v-if="type != 'detail-item'"
                        >
                          <path
                            d="M11.1457 15.0667H11.7707C11.9269 15.0667 12.0832 14.9365 12.0832 14.7542V9.12923C12.0832 8.97298 11.9269 8.81673 11.7707 8.81673H11.1457C10.9634 8.81673 10.8332 8.97298 10.8332 9.12923V14.7542C10.8332 14.9365 10.9634 15.0667 11.1457 15.0667ZM15.4165 6.31673H13.255L12.3696 4.8584C12.1613 4.49382 11.7446 4.2334 11.3019 4.2334H8.67171C8.229 4.2334 7.81234 4.49382 7.604 4.8584L6.71859 6.31673H4.58317C4.3488 6.31673 4.1665 6.52506 4.1665 6.7334V7.15006C4.1665 7.38444 4.3488 7.56673 4.58317 7.56673H4.99984V16.3167C4.99984 17.0199 5.54671 17.5667 6.24984 17.5667H13.7498C14.4269 17.5667 14.9998 17.0199 14.9998 16.3167V7.56673H15.4165C15.6248 7.56673 15.8332 7.38444 15.8332 7.15006V6.7334C15.8332 6.52506 15.6248 6.31673 15.4165 6.31673ZM8.61963 5.56152C8.64567 5.53548 8.69775 5.4834 8.74984 5.4834C8.74984 5.4834 8.74984 5.4834 8.77588 5.4834H11.2238C11.2759 5.4834 11.328 5.53548 11.354 5.56152L11.7967 6.31673H8.17692L8.61963 5.56152ZM13.7498 16.3167H6.24984V7.56673H13.7498V16.3167ZM8.229 15.0667H8.854C9.01025 15.0667 9.1665 14.9365 9.1665 14.7542V9.12923C9.1665 8.97298 9.01025 8.81673 8.854 8.81673H8.229C8.04671 8.81673 7.9165 8.97298 7.9165 9.12923V14.7542C7.9165 14.9365 8.04671 15.0667 8.229 15.0667Z"
                            fill="#FE90A4"
                          />
                        </svg>
                      </BaseInputIcon>
                    </div>
                  </draggable>

                  <BaseButton
                    variant="outline-dashed"
                    @click="addValue(optionIndex)"
                    :disabled="list[optionIndex].disabled"
                  >
                    <template #icon-before>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.5833 9.16667H10.8333V5.41667C10.8333 5.20833 10.625 5 10.4167 5H9.58333C9.34896 5 9.16667 5.20833 9.16667 5.41667V9.16667H5.41667C5.18229 9.16667 5 9.375 5 9.58333V10.4167C5 10.651 5.18229 10.8333 5.41667 10.8333H9.16667V14.5833C9.16667 14.8177 9.34896 15 9.58333 15H10.4167C10.625 15 10.8333 14.8177 10.8333 14.5833V10.8333H14.5833C14.7917 10.8333 15 10.651 15 10.4167V9.58333C15 9.375 14.7917 9.16667 14.5833 9.16667Z"
                        />
                      </svg>
                    </template>
                    Thêm giá trị
                  </BaseButton>
                </div>
              </div>
            </div>

            <BaseButton
              variant="outline-dashed"
              @click="addOption(validate)"
              :disabled="
                list.findIndex((e) => e.name === '') != -1
                  ? true
                  : type === 'detail-item'
                  ? true
                  : false
              "
              v-if="options.length < 5"
            >
              <template #icon-before>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.5833 9.16667H10.8333V5.41667C10.8333 5.20833 10.625 5 10.4167 5H9.58333C9.34896 5 9.16667 5.20833 9.16667 5.41667V9.16667H5.41667C5.18229 9.16667 5 9.375 5 9.58333V10.4167C5 10.651 5.18229 10.8333 5.41667 10.8333H9.16667V14.5833C9.16667 14.8177 9.34896 15 9.58333 15H10.4167C10.625 15 10.8333 14.8177 10.8333 14.5833V10.8333H14.5833C14.7917 10.8333 15 10.651 15 10.4167V9.58333C15 9.375 14.7917 9.16667 14.5833 9.16667Z"
                  />
                </svg>
              </template>
              Thêm thuộc tính
            </BaseButton>
          </div>
        </form>
      </validation-observer>
    </template>

    <template #control-left>
      <el-button
        @click="hidePopupAddProperty"
      >
        Thoát
      </el-button>
    </template>

    <template #control-right>
      <el-button class="n-btn" type="primary" @click="submitAddProperty">
        Hoàn tất
      </el-button>
    </template>
  </LayoutPopup>
</template>

<script>
import Swal from "sweetalert2";
import dublicate from "@/mixins/items/checkDublicate";

export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },

    submit: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: "add-new-item",
    },
  },

  mixins: [dublicate],

  data() {
    return {
      list: this.options.map((option) => {
        return {
          ...option,
          values: option.values.map((value, index) => {
            return {
              text: value,
              id: index,
              error: "",
            };
          }),
          error: "",
          disabled: option.disabled == false ? false : true,
        };
      }),
      resulValidate: false,
    };
  },

  methods: {
    hidePopupAddProperty() {
      this.hidePopup("them-thuoc-tinh");
      this.list = this.options.map((option) => {
        return {
          ...option,
          values: option.values.map((value, index) => {
            return {
              text: value,
              id: index,
              error: "",
            };
          }),
          error: "",
          disabled: option.disabled == false ? false : true,
        };
      });
    },

    getValue(event, optionIndex, index) {
      this.list[optionIndex].values[index].text = event;
      let result = this.list[optionIndex].values.findIndex(
        (e) => e.text === ""
      );

      if (result === -1) {
        this.list[optionIndex].disabled = false;
      } else {
        this.list[optionIndex].disabled = true;
      }
    },

    addValue(optionIndex) {
      let result = this.list[optionIndex].values.findIndex(
        (e) => e.text === ""
      );
      if (result === -1) {
        this.list[optionIndex].values.push({
          text: "",
          id: this.list[optionIndex].values.length,
          error: "",
        });
        this.list[optionIndex].disabled = true;
      }
    },

    addOption() {
      let result = this.list.findIndex((e) => e.name === "");

      if (result === -1) {
        this.list.push({
          name: "",
          error: "",
          values: [
            {
              text: "",
              id: 0,
              error: "",
            },
          ],
          disabled: true,
        });
      }
    },

    deleteValue(optionIndex, index) {
      const result = this.list[optionIndex].values.findIndex((e) => e === "");
      if (result === -1) {
        this.list[optionIndex].disabled = false;
      }
      if (index != 0) {
        this.list[optionIndex].values.splice(index, 1);
      } else {
        this.list[optionIndex].values[index].text = "";
      }
    },

    deleteOption(optionIndex) {
      if (this.list[optionIndex].name != "") {
        Swal.fire({
          html: "Thao tác này không thể hoàn tác.",
          confirmButtonColor: "#d33",
          confirmButtonText: "Xoá thuộc tính",
          cancelButtonColor: "#34c38f",
          cancelButtonText: "Huỷ",
          imageUrl: require("@/assets/images/exclamation-triangle.svg"),
          showCancelButton: true,
          imageWidth: 125,
          imageHeight: 125,
        }).then((result) => {
          if (result.isConfirmed) {
            if (optionIndex != 0 && this.list.length > 1) {
              this.list.splice(optionIndex, 1);
            } else {
              this.list.splice(0, 1, {
                name: "",
                values: [
                  {
                    text: "",
                    id: 0,
                    error: "",
                  },
                ],
                error: "",
                disabled: true,
              });
            }
          }
        });
      } else if (this.list[optionIndex].name === "" && optionIndex != 0) {
        this.list.splice(optionIndex, 1);
      }
    },

    formatOutput(list) {
      let result = list.map((option) => {
        return {
          name: option.name.trim(),
          disabled: option.disabled,
          values: option.values.map((value) => value.text.trim()),
        };
      });
      console.log(result.filter((e) => e.name != "" && e.values[0] != ""));
      return result.filter((e) => e.name != "" && e.values[0] != "");
    },

    checkValidate() {
      // check giá trị bắt buộc và không trùng của giá trị thuộc tính
      this.list.map((e, indexProperty) => {
        e.values.map((value, indexValue) => {
          let list = e.values.map((e) => e.text);
          let result = this.dublicate(value.text, list);
          if (result) {
            this.list[indexProperty].values[indexValue].error =
              "Giá trị không được trùng";
          } else if (
            value.text === "" &&
            this.list[indexProperty].name != "" &&
            indexProperty === 0
          ) {
            this.list[indexProperty].values[indexValue].error =
              "Giá trị không được bỏ trống";
          } else if (value.text === "" && indexProperty != 0) {
            this.list[indexProperty].values[indexValue].error =
              "Giá trị không được bỏ trống";
          } else {
            this.list[indexProperty].values[indexValue].error = "";
          }
        });
      });

      // check giá trị bắt buộc và không trùng của thuộc tính
      let listName = this.list.map((e) => e.name);
      this.list.map((e, index) => {
        let result = this.dublicate(e.name, listName);
        let resultValue = e.values.findIndex((value) => {
          return value.text === "";
        });
        if (result) {
          this.list[index].error = "Thuộc tính không được trùng";
        } else if (e.name === "" && resultValue == -1 && index === 0) {
          this.list[index].error = "Thuộc tính không được bỏ trống";
        } else if (e.name === "" && index != 0) {
          this.list[index].error = "Thuộc tính không được bỏ trống";
        } else {
          this.list[index].error = "";
        }
      });
    },

    async submitAddProperty() {
      await this.$refs.observerPropertyItems.validate();
      await this.checkValidate();

      let el = document.querySelector("#observerPropertyItems .is-invalid");

      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        el.focus();
      } else if (this.type === "detail-item") {
        Swal.fire({
          html: "Thao tác này không thể hoàn tác.",
          confirmButtonColor: "#d33",
          confirmButtonText: "Xác nhận",
          cancelButtonColor: "#34c38f",
          cancelButtonText: "Huỷ",
          imageUrl: require("@/assets/images/exclamation-triangle.svg"),
          showCancelButton: true,
          imageWidth: 125,
          imageHeight: 125,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$emit("options", this.formatOutput(this.list));
            this.hidePopup("them-thuoc-tinh");
          }
        });
      } else {
        this.$emit("options", this.formatOutput(this.list));
        this.hidePopup("them-thuoc-tinh");
      }
    },
  },

  watch: {
    options: {
      handler: function () {
        this.list = this.options.map((option) => {
          return {
            ...option,
            values: option.values.map((value, index) => {
              return {
                text: value,
                id: index,
                error: "",
              };
            }),
            error: "",
            disabled: option.disabled == false ? false : true,
          };
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.__options {
  button {
    width: 100%;
  }

  > *:not(:first-child) {
    margin-top: 16px;
  }
}

.__option {
  padding: 16px;

  background: #f1f2f4;
  border-radius: 4px;

  > *:not(:first-child) {
    margin-top: 16px;
  }
}

.__controls {
  display: flex;
  justify-content: flex-end;
}

.__field {
  width: 100%;
  display: grid;
  grid-template-columns: 80px 1fr;
  gap: 24px;

  place-content: center;
  place-items: start;
  .__label {
    width: 100%;
    margin: 0;
    text-align: left;
    padding: 12px 0;

    &.__required {
      &:after {
        content: " *";
        color: red;
      }
    }
  }

  .__inputs {
    width: 100%;
    display: flex;
    flex-flow: column;
    gap: 8px;
  }
}
</style>
